export default "__VITE_ASSET__BeBSF_V9__"